import { render, staticRenderFns } from "./BackupCodesModal.vue?vue&type=template&id=47c2fece&"
import script from "./BackupCodesModal.vue?vue&type=script&lang=js&"
export * from "./BackupCodesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BackupCodesModal.vue"
export default component.exports